import React from 'react'

import './index.scss'

export const LineIcon: React.FC = () => (
  <svg
    className="icon icon--line"
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path className="stroke" d="M5.33333 10H14.6667" strokeLinecap="square" />
  </svg>
)
